import { useEffect, useState } from 'react';
import api from './api';

// Hook to fetch a configurable lookup list (hosting providers, domain
// registrars, telecom operators) backed by /api/lookups/{kind}. If the
// API call fails (network blip, fresh DB before seed runs, etc.) we
// fall back to the caller-provided `fallback` array so the UI never
// shows an empty dropdown. Returns string names sorted by `order`.
export const useLookup = (kind, fallback = []) => {
  const [options, setOptions] = useState(fallback);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get(`/lookups/${kind}`);
        if (cancelled) return;
        if (r.data?.success && Array.isArray(r.data.data) && r.data.data.length) {
          setOptions(r.data.data.map(x => x.name));
        }
      } catch { /* keep fallback */ }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, [kind]);

  return { options, loading };
};
